import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SurveyCreator from "../surveyjs/SurveyCreator";
import MDBox from "components/MDBox";

function Creator() {
	return (
		<DashboardLayout>
			<DashboardNavbar />
			<MDBox sx={{ width: "100%", height: "95vh" }}>
				<SurveyCreator />
			</MDBox>
		</DashboardLayout>
	);
}

export default Creator;
